export default "__VITE_ASSET__DPNuUHSf__"